module.exports = __webpack_public_path__ + "static/media/13223.1a360c8a.jpg";